import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BaiduMap from "vue-baidu-map";
import { Layout } from "ant-design-vue";
//绘图包
import * as echarts from "echarts";
import HighchartsVue from "highcharts-vue";
//表格
// import i18n from "./i18n";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

//表格国际化
import VueI18n from "vue-i18n";
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
import enUS from "vxe-table/lib/locale/lang/en-US";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en_US", // 默认语言为英语
  messages: {
    zh_CN: {
      ...zhCN,
    },
    en_US: {
      ...enUS,
    },
  },
});

VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.t(key, args),
});

//复制粘贴
import clipboard from "clipboard";
//浏览器标签
import Meta from "vue-meta";

import {
  Button,
  Icon,
  Menu,
  Divider,
  Table,
  BackTop,
  Card,
  Space,
  Steps,
  Carousel,
  Col,
  Timeline,
  Tabs,
  Drawer,
  Tag,
  Badge,
  Input,
  Form,
  Tooltip,
  AutoComplete,
  List,
  Switch,
  Result,
  message,
  Select,
  Radio,
  Statistic,
  Modal,
  Anchor,
  Affix,
  Skeleton,
  Spin,
  Collapse,
  Popover,
  Descriptions,
  Alert,
  Row,
  InputNumber,
  Slider,
  notification,
  Avatar,
  Upload,
} from "ant-design-vue";
//import "ant-design-vue/dist/antd.less";
//import Antd from "ant-design-vue";

Vue.config.productionTip = false;

Vue.use(Button);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Menu);
Vue.use(Divider);
Vue.use(Table);
Vue.use(BackTop);
Vue.use(Card);
Vue.use(Space);
Vue.use(Steps);
Vue.use(Carousel);
Vue.use(Col); // 栅格系统
Vue.use(Timeline);
Vue.use(Tabs);
Vue.use(Drawer);
Vue.use(Tag);
Vue.use(Badge);
Vue.use(Input);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(AutoComplete);
Vue.use(List);
Vue.use(Switch);
Vue.use(Result);
Vue.use(Select);
Vue.use(Radio);
Vue.use(Statistic);
Vue.use(Modal);
Vue.use(Anchor);
Vue.use(Affix);
Vue.use(Skeleton);
Vue.use(Spin);
Vue.use(Collapse);
Vue.use(Popover);
Vue.use(Descriptions);
Vue.use(Alert);
Vue.use(BaiduMap, { ak: "8iHhc15A2TTwlHE5yNVklPj5I1T5fpBt" });
Vue.use(VXETable);
Vue.use(Row);
Vue.use(InputNumber);
Vue.use(Slider);
Vue.use(notification);
Vue.use(message);
Vue.use(Avatar);
Vue.use(Upload);
// Vue.use(echarts);
Vue.prototype.$message = message; //message 一定要用vue原型去挂载调用
Vue.prototype.$notification = notification; //message 一定要用vue原型去挂载调用
Vue.prototype.$echarts = echarts; //在原型种绑定echarts
Vue.use(HighchartsVue); //在原型种绑定highcharts
Vue.prototype.clipboard = clipboard; //复制粘贴

//浏览器标签
Vue.use(Meta);

new Vue({
  i18n,
  router,
  store,
  metaInfo: {
    title: "PerturbDB",
    meta: [
      { name: "keywords", content: "PerturbDB" },
      { name: "description", content: "PerturbDB" },
    ],
  },
  render: (h) => h(App),
}).$mount("#app");
